import { action } from 'sky-engine/api/index'

import { SOFTWARE_MNG } from '@/api/apiModules'
/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function getSoftwareList(params) {
  return action(SOFTWARE_MNG, 'list', params)
}
